import React from "react";
import SchoolReports from "../shared/reports/SchoolReports";

function ControllerSchoolReportsPage({ students }) {
  return <SchoolReports students={students} />;
}

export default ControllerSchoolReportsPage;
